import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '../../../../lib/cn';
import { PALETA_AREAS } from '../paletaAreas';

/**
 * ColorPicker — selector de color por SWATCHES de la paleta del catálogo (§3.5). NUNCA input
 * type=color: solo se puede elegir un color de la lista curada (PALETA_AREAS).
 *
 * Si el `value` actual no está en la paleta (dato antiguo o futuro), se antepone como swatch
 * "Actual" para que salga marcado al editar y no se pierda al guardar sin tocarlo.
 *
 * props: value(hex) · onChange(hex) · disabled
 */
export default function ColorPicker({ value, onChange, disabled = false }) {
  const enPaleta = PALETA_AREAS.some((c) => c.valor.toLowerCase() === (value || '').toLowerCase());
  const swatches = enPaleta || !value
    ? PALETA_AREAS
    : [{ valor: value, nombre: 'Actual' }, ...PALETA_AREAS];

  return (
    <div role="radiogroup" aria-label="Color del área" className="flex flex-wrap gap-2">
      {swatches.map((c) => {
        const activo = (value || '').toLowerCase() === c.valor.toLowerCase();
        return (
          <button
            key={c.valor}
            type="button"
            role="radio"
            aria-checked={activo}
            aria-label={c.nombre}
            title={c.nombre}
            disabled={disabled}
            onClick={() => onChange?.(c.valor)}
            className={cn(
              'relative h-8 w-8 rounded-full border transition-transform',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-v25-focus',
              activo ? 'scale-110 border-v25-ink-700 ring-2 ring-v25-ink-300' : 'border-black/10 hover:scale-105',
              disabled && 'cursor-not-allowed opacity-50',
            )}
            style={{ backgroundColor: c.valor }}
          >
            {activo && <Check className="absolute inset-0 m-auto h-4 w-4 text-white drop-shadow" />}
          </button>
        );
      })}
    </div>
  );
}
